const ImageCache = require("./ImageCache");

/**
 * Houses all the attributes and magic numbers that are used to scale the diagrams such
 * that the looking glass' lens is aligned perfectly to the cropped circle. They are
 * grouped together to highlight the fact that if the asset changes in any way, the
 * magic numbers will almost definitely need to be tweaked because they are unique
 * to the existing asset.
 *
 * @param {Number} r Radius of the cropped circle
 * @returns Object
 */
const getAssetAttributes = function(r = 0) {
	const scale = 2.2;
	const aspectRatio = 447 / 232;

	return {
		imagePath: global.BASE_URL + "assets/images/problem-art/looking-glass.svg",
		// magic numbers for this asset
		nodeScaleX: 2.75,
		nodeScaleY: 1.1,
		imageOffsetX: 1.65 * r,
		imageOffsetY: 1.1 * r,
		imageWidth: aspectRatio * scale * r,
		imageHeight: scale * r,
	};
};

/**
 * Draws a looking glass, with the lens' location centered on a circle with center
 * (centerX, centerY) and radius r.
 *
 * @param {CanvasRenderingContext2D} context Canvas context to render in
 * @param {Number} x X-point center of circle
 * @param {Number} y Y-point center of circle
 * @param {Number} r Radius of circle
 */
const drawLookingGlass = function(context, x, y, r) {
	const {
		imagePath,
		imageOffsetX,
		imageOffsetY,
		imageWidth,
		imageHeight,
	} = getAssetAttributes(r);
	const image = ImageCache.src(imagePath, true);

	context.save();
	context.globalCompositeOperation = "source-over";
	context.drawImage(
		image,
		x - imageOffsetX,
		y - imageOffsetY,
		imageWidth,
		imageHeight
	);

	context.restore();
};

module.exports = {
	getAssetAttributes,
	drawLookingGlass,
};
